export enum TRADE_PAGE_TABLE_RESIZE_OPTION {
	SMALL = '160',
	MEDIUM = '210',
	FULL = '360',
	MINIMIZE = '0',
}

export const TRADE_PAGE_TABLE_DEFAULT_SIZE =
	TRADE_PAGE_TABLE_RESIZE_OPTION.MEDIUM;
